import Vue from 'vue'
import axios from 'axios'
import {
  _COMMIT_LOG,
} from '../actions.types'

export default {
  // Invoices
  async getInvoice ({ state, commit, dispatch }, payload) {
    try {
      console.log('Retrieving invoice...', payload)
      const headers = {}
      if (payload.authToken && payload.authToken.length > 0) {
        headers.Authorization = `Bearer ${payload.authToken}`
      }
      const { data } = await axios.get(`${process.env.VUE_APP_API_URL}/api/v1/account/${payload.account_key}/invoice/${payload.invoice_key}`, { headers: headers, params: payload })
      console.log(data)
      return data[0]
    } catch (error) {
      // await dispatch('processAxiosError', error)
      console.log(error)
      return []
    }
  },
  // Payment
  async getPayment ({ state, commit, dispatch }, payload) {
    try {
      dispatch(_COMMIT_LOG, { message: 'Retrieving payment...', payload })
      const headers = {}
      if (payload.authToken && payload.authToken.length > 0) {
        headers.Authorization = `Bearer ${payload.authToken}`
      }
      const { data } = await axios.get(`${process.env.VUE_APP_API_URL}/api/v1/account/${payload.account_key}/payment/${payload.payment_key}`, { headers: headers, params: payload })
      console.log(data)
      return data[0]
    } catch (error) {
      // await dispatch('processAxiosError', error)
      console.log(error)
      return []
    }
  },

  getShopProducts (context, page) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get('/api/user/products/get', { params: { page } })
        .then(({ body }) => {
          context.commit('SET_PRODUCTS', body)
          resolve()
        })
        .catch(error => reject(error))
    })
  },

  getProductsByUser (context) {
    return new Promise((resolve, reject) => {
      Vue.http
        .get('/api/user/products/getProductsByUser')
        .then(({ body }) => {
          context.commit('SET_PRODUCTS', body)
          resolve()
        })
        .catch(error => reject(error))
    })
  },
}
